import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import { highlight } from '../summary-conf';
import { IncludeExcludeLayout } from 'widgets-v6/layout';
/** import classes and others in the section above, keep the ascending order */

export default highlight(
    class extends React.Component {
        render() {
            const style = this.props.strikethroughText
                ? {
                      textDecoration: 'line-through',
                      color: 'gray',
                  }
                : this.props.highlight
                ? { background: '#ffaaaa' }
                : null;

            const { doohPublishers } = this.props;

            // Map publisher IDs to names
            const IncludedPublisherNames = doohPublishers
                .filter(pub => this.props.value.include.includes(pub.publisher_id))
                .map(pub => pub.publisher_name);
            const ExcludedPublisherNames = doohPublishers
                .filter(pub => this.props.value.exclude.includes(pub.publisher_id))
                .map(pub => pub.publisher_name);
            const includes = (
                <div className="regions" key={_.uniqueId()}>
                    <IncludeExcludeLayout type="Include" marginBottom>
                        {IncludedPublisherNames.join(', ')}
                    </IncludeExcludeLayout>
                </div>
            );
            const excludes = (
                <div className="regions" key={_.uniqueId()}>
                    <IncludeExcludeLayout type="Exclude" marginBottom>
                        {ExcludedPublisherNames.join(', ')}
                    </IncludeExcludeLayout>
                </div>
            );

            return (
                <dl className="ef3-adSummaryView_panelBlock">
                    <div className="ef3-adSummaryView__item-group">
                        <dt className="ef3-adSummaryView_term">{this.props.keyName}</dt>
                        <dd className="ef3-adSummaryView_description" style={style}>
                            {includes}
                            {excludes}
                        </dd>
                        {this.props.tooltip}
                    </div>
                </dl>
            );
        }
    },
    (currentProps, nextProps) => {
        let hasChanged;
        const value_strgf_next = JSON.stringify(nextProps.value);
        const value_strgf_prev = JSON.stringify(currentProps.value);

        hasChanged = value_strgf_prev !== value_strgf_next;
        return hasChanged;
    }
);
